var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sso"},[_c('transition',{attrs:{"name":"expand","mode":"out-in"}},[_c(_vm.curComponent,{tag:"component",on:{"ssoLogout":function($event){_vm.curComponent=_vm.ssoLogout},"ssoLogin":function($event){_vm.curComponent=_vm.ssoLogin}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }